import axios from 'axios'
import { host } from '../config/env'
import router from '../router'
import qs from 'qs'
import store from '../store'
import base from '../../static/js/base.js'
import { MessageBox } from 'mint-ui'

// 配置axios的默认URL
axios.defaults.baseURL = host
// // 配置axios请求头
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
// 添加token
// axios.defaults.headers.common['token'] = store.state.login.token;
// 请求头添加设备号
// axios.defaults.headers.common['uuid'] = base.data.uuid;
// 配置允许跨域携带cookie
// axios.defaults.withCredentials = true;
// 配置超时时间
// axios.defaults.timeout = 10000;

// 请求拦截器
axios.interceptors.request.use(
  config => {
    // 在发送请求之前做某事
    if (config.method === 'post') {
      config.data = qs.stringify({ token: store.state.login.token, timestamp: new Date().getTime(), ...config.data })
    } else if (config.method === 'get') {
      config.params = {
        token: store.state.login.token,
        timestamp: new Date().getTime(),
        ...config.params
      }
    }
    return config
  },
  error => {
    // 请求错误时做些事
    return Promise.reject(error)
  })

// response全局拦截
axios.interceptors.response.use(function(response) {
  // 对响应数据做点什么
  if (response.data.code === 1001 || response.data.resMsg === 'please login' || response.data.resMsg === 'TOKEN错误') { // 未进行登陆或者登陆过期
    MessageBox.close()
    MessageBox.alert('登录过期！请重新登录').then(actions => { // 提示框点击确认时执行函数
      store.commit('USER_SIGNOUT')
      router.replace('/login')
    })
  }
  if (response.data.statusNum) {
    response.data.statusNum = JSON.parse(response.data.statusNum)
    if (!response.data.statusNum) {
      base.error()
    }
  } else {
    MessageBox.close()
    MessageBox('提示', response.data.resMsg)
  }
  return response
}, function(error) {
  // 对响应错误做点什么
  return Promise.reject(error)
})

export default axios



// WEBPACK FOOTER //
// ./src/api/http.js